import { Skeleton } from "../../../component/ui/Skeleton";
import React from "react";

type ITotalCard = {
  title: string;
  total: number | string;
  loading: boolean;
  activeCount?: number | string;
  subtitleLoading?: boolean;
  countText?: string;
};

const TotalCountCard = ({
  title,
  total,
  loading,
  activeCount,
  subtitleLoading = false,
  countText = "Active",
}: ITotalCard) => {
  return (
    <div className="w-full h-[120px] shadow-sm p-4 flex justify-between rounded-xl bg-white">
      <h5 className="text-lg font-medium">{title}</h5>

      <div>
        <div>
          {loading ? (
            <Skeleton className="h-10 w-24" />
          ) : (
            <h5 className="text-right text-4xl font-bold">{total}</h5>
          )}
        </div>

        <div className="flex items-center justify-center gap-2">
          <div>{countText}:</div>
          <div>
            {subtitleLoading ? (
              <Skeleton className="h-5 w-10" />
            ) : (
              <span className="!text-primary self-center">{activeCount}</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TotalCountCard;
